import TileSource from 'ol/source/Tile';
import './MapTileProgressBar.scss';


export class MapTileProgressBar {
    element: HTMLElement;
    loading: number = 0;
    loaded: number = 0;

    constructor() {
        if (document.getElementById('map-tile-progress-bar')) {
            document.getElementById('map-tile-progress-bar').remove();
        }
        this.element = document.createElement('div');
        this.element.id = 'map-tile-progress-bar';

        const appHeader = document.querySelector('#app__header');
        if (appHeader) {
            this.element.style.top = appHeader.getBoundingClientRect().height + 'px';
        }

        document.body.appendChild(this.element);
    }

    attachEvents(source: TileSource): (OlEventsKey | OlEventsKey[])[] {
        const eventKeys: (OlEventsKey | OlEventsKey[])[] = [];
        eventKeys.push(source.on('tileloadstart', this.addLoading));
        eventKeys.push(source.on('tileloadend', this.addLoaded));
        eventKeys.push(source.on('tileloaderror', this.addLoaded));
        return eventKeys;
    }

    addLoading = () => {
        if (this.loading == 0) {
            this.show();
        }
        this.loading++;
        this.update();
    }

    addLoaded = () => {
        setTimeout(() => {
            this.loaded++;
            this.update();
        }, 100);
    }

    reset = () => {
        this.loading = 0;
        this.loaded = 0;

        setTimeout(this.hide, 500);
    }

    update = () => {
        // Allow only values between 15% and 100% to always show the progress bar when something is being loaded
        const width = Math.min(Math.max((this.loaded / this.loading * 100), 15), 100).toFixed(1) + '%';

        this.element.style.width = width;

        if ((this.loading - this.loaded) <= 0) {
            this.reset();
        }
    }

    show = () => {
        this.element.style.visibility = 'visible';
    }

    hide = () => {
        if (this.loading === this.loaded) {
            this.element.style.visibility = 'hidden';
            this.element.style.width = '0';
        }
    }
}
